import { render, staticRenderFns } from "./LeftSideMenu.vue?vue&type=template&id=1fab3cda&scoped=true"
import script from "./LeftSideMenu.vue?vue&type=script&lang=js"
export * from "./LeftSideMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftSideMenu.vue?vue&type=style&index=0&id=1fab3cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fab3cda",
  null
  
)

export default component.exports